import createContextFactory from "@Utils/factory"

import { useTableResize } from "./hooks"

const { Provider, useContext } = createContextFactory(useTableResize)

export {
  useContext as useTableContext,
  Provider as TableProvider,
}
